import { Alert, Snackbar } from "@mui/material";
import React, { createContext, ReactNode, useState } from "react";

type SnackbarContextType = {
  openSuccessSnackbar: (message: ReactNode) => void;
  openErrorSnackbar: (message: ReactNode) => void;
};

export const SnackbarContext = createContext<SnackbarContextType>({
  openSuccessSnackbar: () => {},
  openErrorSnackbar: () => {},
});

type SnackbarProviderProps = {
  children: ReactNode;
};

type SnackbarType = { open: boolean; message: ReactNode; severity: string };

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  const [snackbar, setSnackbar] = useState<SnackbarType>({
    open: false,
    message: "",
    severity: "success",
  });

  const openSuccessSnackbar = (message: ReactNode) => {
    setSnackbar({ open: true, message, severity: "success" });
  };

  const openErrorSnackbar = (message: ReactNode) => {
    setSnackbar({ open: true, message, severity: "error" });
  };

  return (
    <SnackbarContext.Provider
      value={{ openSuccessSnackbar, openErrorSnackbar }}
    >
      {children}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity === "error" ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};
